import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import vuetify from '@/plugins/vuetify'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

/**
 * setting of vue analytics
 * @see https://github.com/MatteoGabriele/vue-analytics
 */
Vue.use(VueAnalytics, {
  id: 'UA-120355435-2',
  router
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
